module.exports = __webpack_public_path__ + "7396f8b723ad63c82d101cc2a4409343.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.relic.com/src/img/styles/12_column_large_x1/public/history/8.jpg
// module id = 257
// module chunks = 0